import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=619c40c8"
import script from "./PrimaryButton.vue?vue&type=script&lang=js"
export * from "./PrimaryButton.vue?vue&type=script&lang=js"
import style0 from "./PrimaryButton.vue?vue&type=style&index=0&id=619c40c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports